import type { ImgHTMLAttributes } from 'react';
import { cn } from '@/lib/utils/cn';
import blazeLogoUrl from '@/assets/blaze-logo.svg';

interface BlazeLogoProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'width' | 'height' | 'alt'> {
  size?: number;
  alt?: string;
  decorative?: boolean;
}

/** Canonical public Blaze mark supplied by the brand team. */
export function BlazeLogo({
  size = 48,
  alt = 'Blaze',
  decorative = false,
  className,
  ...props
}: BlazeLogoProps) {
  return (
    <img
      src={blazeLogoUrl}
      width={size}
      height={size}
      alt={decorative ? '' : alt}
      aria-hidden={decorative || undefined}
      draggable={false}
      className={cn('shrink-0 select-none', className)}
      {...props}
    />
  );
}
